import { combineReducers } from "redux";
import {pageBuilderReducer} from "./reducer/pageBuilderReducer";

const rootReducer = combineReducers({
  pageBuilder: pageBuilderReducer,
  
});

export default rootReducer;
